export default __webpack_public_path__ + "static/media/FODL.f75e549c.png";